import styled from 'styled-components'

export const PickerBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Options = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 360px;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  list-style: none;
`

export const Option = styled.li<{ $selected: boolean }>`
  padding: 16px;
  border: 1px solid ${({ $selected }) => ($selected ? '#0669f5' : '#f0f0f0')};
  border-radius: 8px;
  background: ${({ $selected }) => ($selected ? '#e7f3fe' : '#ffffff')};
  cursor: pointer;
  transition: border-color 200ms ease;

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 4px #002a6d3d, 0 1px 2px 0 #0e0e0e0a;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`

export const OptionName = styled.span`
  display: block;
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #363636;
`

export const OptionMeta = styled.span`
  display: block;
  font-size: 12px;
  line-height: 16px;
  color: #757575;
`

export const OptionDescription = styled.span`
  display: block;
  margin-top: 4px;
  font-size: 12px;
  line-height: 16px;
  color: #363636;
`

export const Status = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 20px;
  color: #757575;
`
